import { SeoRenderer } from "../../../common/helpers/seo";

import loadingComponent from "./loadable";

export default {
    component: loadingComponent,
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({ title: allMessage["error.404.title"], allMessage, lang });
    },
};
